export default __webpack_public_path__ + "static/media/empty-chats.f5e8883c.png";